import { TableStatus } from '../../common/TableStatus';

interface TargetsTableStatusProps {
  enabled: boolean;
}

export function TargetsTableStatus({ enabled }: TargetsTableStatusProps) {
  const variant = enabled ? 'success' : 'error';
  const status = enabled ? 'ENABLED' : 'DISABLED';

  return <TableStatus status={status} variant={variant} />;
}
